import React from 'react';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {PrimaryButton, DangerButton} from 'Components/Button';

import {translation} from 'Services/TranslationHelpers';

export default class Highlights extends React.Component {
    /**
     * @method handleConfirm
     * @return {Promise<void>}
     */
    handleConfirm = async () => {
        await this.props.onConfirm();
        this.props.onClose();
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {message} = this.props;

        return (
            <Modal>
                <ModalHeader onClose={this.props.onClose}>
                   2024 Highlights
                </ModalHeader>
                 <ModalBody>
                    <div className="aspect-w-16 aspect-h-9">
                        <iframe
                            src="https://www.youtube.com/embed/aeJi0-Tb0lo?si=gd0yXPh6D1hhjn4w"
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                </ModalBody>
                <ModalFooter alignment="center">
                    <PrimaryButton
                        className="mr-2"
                        text={translation('misc', 'close')}
                        onClick={this.props.onClose} />
                </ModalFooter>
            </Modal>
        )
    }
};
